import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
        <div className="flex-1">
          <h2 className="text-foreground-950 font-heading text-3xl md:text-4xl font-bold mb-8 leading-tight">
            {t('about.title')}
          </h2>
          <div className="space-y-5 text-foreground-700 text-base leading-relaxed max-w-lg">
            <p>{t('about.paragraph1')}</p>
            <p>{t('about.paragraph2')}</p>
            <p>{t('about.paragraph3')}</p>
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-accent-100/80 text-foreground-900 rounded-full text-sm font-medium hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('about.cta')}
            <i className="ri-arrow-right-line"></i>
          </a>

          <div className="flex items-center gap-16 mt-14">
            <div>
              <p className="text-foreground-950 font-heading text-4xl font-bold">{t('about.stat1')}</p>
              <p className="text-foreground-500 text-sm mt-1">{t('about.stat1Label')}</p>
            </div>
            <div>
              <p className="text-foreground-950 font-heading text-4xl font-bold">{t('about.stat2')}</p>
              <p className="text-foreground-500 text-sm mt-1">{t('about.stat2Label')}</p>
            </div>
          </div>
        </div>

        <div className="flex-1">
          <div className="relative rounded-[32px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20vertical%20product%20photography%20of%20a%20curated%20fashion%20collection%20featuring%20a%20cream%20leather%20handbag%20a%20pair%20of%20beige%20suede%20loafers%20and%20a%20soft%20cashmere%20throw%20draped%20gracefully%20on%20a%20warm%20limestone%20surface%20with%20soft%20diffused%20natural%20light%20from%20above%20creating%20gentle%20shadows%20refined%20Italian%20editorial%20style%20warm%20neutral%20tones%20luxurious%20minimalist%20aesthetic&width=900&height=1100&seq=about-img-v2&orientation=portrait"
              alt="Itaobuy Spreadsheet ricerca prodotti"
              title="Itaobuy Spreadsheet ricerca prodotti"
              className="w-full h-auto object-cover"
            />
            <div className="absolute top-5 left-5">
              <span className="inline-flex px-4 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800">
                Milano, IT
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
              <p className="text-background-50 font-heading text-lg font-semibold">Itaobuy Spreadsheet</p>
              <p className="text-background-50/70 text-sm">Database Prodotti Italiano</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}